export default {
  title: "Créer un lien d'intégration",
  steps: {
    select_gateway: 'Sélectionner la passerelle',
    copy_link: 'Copier le lien',
  },
  select_gateway: {
    description:
      "Choisissez la passerelle de paiement pour laquelle vous souhaitez générer un lien d'intégration durable.",
  },
  link: {
    proxy_url_label: "URL d'intégration",
    expires_label: 'Expire le',
    copy_button: "Copier l'URL",
    copied: 'Copié !',
    description:
      "Partagez cette URL avec le marchand. Elle redirige vers la page d'intégration de la passerelle et reste valide jusqu'à la date d'expiration.",
  },
  buttons: {
    next: 'Suivant',
    back: 'Retour',
    done: 'Terminé',
  },
  toasts: {
    create_success: "Lien d'intégration créé avec succès.",
    create_failed: "Échec de la création du lien d'intégration.",
  },
};
